import React from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";

import ListAltIcon from "@material-ui/icons/ListAlt";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { utcToLocal } from "../../utils/datetime";

export default function RecentActivities({ activitiesList, ...props }) {
  const { t } = useTranslation();

  const getTranslated = string => {
    let currentString = string;
    const regex = /\bt\("([A-Za-z0-9-:.]*)\b"\)/g;

    let translationCode = currentString.match(regex);

    if (translationCode && translationCode.length > 0) {
      translationCode.forEach(str => {
        currentString = currentString.replace(str, eval(str));
      });
    }

    return currentString;
  };
  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <ListAltIcon />
        </div>
        <div className={styles.title}>{t("dashboard.coach.recentTask")}</div>
      </div>
      <div className={styles.body}>
        {activitiesList &&
          activitiesList.map((item, index) => {
            const dateRegex = /<\s*span[^>]*>(.*?)<\s*\/\s*span>/g;
            let dateValue = item.messages.match(dateRegex)
              ? item.messages.match(dateRegex)[0]
              : "";
            dateValue = dateValue.replace("<span>", "").replace("</span>", "");
            if (dateValue !== "") {
              item.messages = item.messages.replace(
                dateValue,
                utcToLocal(dateValue).format("DD MMM YYYY h:mm A")
              );
            }

            let message = item.messages
              .replace("{{<span>", "")
              .replace("</span>}}", "")
              .replace("{{", "")
              .replace("}}", "");

            return (
              <div className={styles.item} key={index}>
                <Link to={`dashboard/${item.sent_to_uid}?name=${item.coach}`}>
                  <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: getTranslated(message) }}
                  ></div>
                </Link>
                <div className={styles.timestamp}>
                  {dayjs(item.activity_time).format("DD MMM YYYY, HH:mm A")}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
